export const UPGRADE_ACCOUNT_TYPE = {
  RECRUITER: 'recruiter',
  CANDIDATE: 'candidate',
};
